import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateCargoItems } from 'api/cargo-items/use-create-cargo-items.ts';
import type { TCargoType } from 'api/swagger';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { CargoItemCreateForm } from 'components/cargos/cargo-item-create/components/cargo-item-create-form';
import type { ICargoItemCreateFormFields } from 'components/cargos/cargo-item-create/components/cargo-item-create-form';
import { FormDrawerWithButton, EFormDrawerSize } from 'components/common/form-drawer-with-button';

interface ICargoCreateProps {
  cargoId: number;
  cargoType: TCargoType;
}

export const CargoItemCreateComponent: React.FC<ICargoCreateProps> = (props) => {
  const { cargoId, cargoType } = props;
  const { t } = useTranslation();

  const { mutateAsync: createCargoItems, isLoading } = useCreateCargoItems(cargoId);

  const handleFinish = async (values: ICargoItemCreateFormFields) => {
    await createCargoItems(values);
  };

  return (
    <FormDrawerWithButton
      formComponent={CargoItemCreateForm}
      formProps={{ cargoType }}
      title={t('cargo:add_cargo_items')}
      buttonType='default'
      buttonLabel={t('cargo:add_cargo_items')}
      isLoading={isLoading}
      size={EFormDrawerSize.LARGE}
      onFinish={handleFinish}
    />
  );
};

export const CargoItemCreate = withRoleGuard<ICargoCreateProps>(CargoItemCreateComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.customer_manager,
]);
